export default __webpack_public_path__ + "static/media/IMG_2709.5a4c76bc.jpg";